import {AddItemResponseStatus_Success_Section_BasketUrgency_InfoBox} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/add_item_status.types';
import {useTranslation} from '@aboutyou/i18n';
import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {
  ContentPopper,
  Flyout,
  ModalDialog,
  SecondaryContentPopperButton,
  Text,
  Z_INDEXES,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const BASKET_URGENCY_INFO_KEY = 'BASKET_URGENCY_FLYOUT';

export const BasketUrgencyInfo: React.FC<{
  infoBox: AddItemResponseStatus_Success_Section_BasketUrgency_InfoBox;
}> = ({infoBox}) => {
  const {t} = useTranslation();
  const {cancel, isOpen} = useOpenedStateManager(BASKET_URGENCY_INFO_KEY);

  return (
    <StyledContentPopper
      data-testid="basketUrgencyHintInfo"
      open={isOpen}
      LayoutComponent={process.env.STACK === 'mobile' ? Flyout : ModalDialog}
      onClose={cancel}
      renderInPortal
      fixedSmallWidth={false}
      headerContent={
        <Headline
          size="px16"
          weight="mediumHeavy"
          as="p"
          textAlignment="center"
        >
          {infoBox.title}
        </Headline>
      }
      bodyContent={
        <Wrapper>
          <Text>{infoBox.description}</Text>
        </Wrapper>
      }
      footerContent={
        <SecondaryContentPopperButton label={t('Close')} onClick={cancel} />
      }
    />
  );
};

const StyledContentPopper = styled(ContentPopper)`
  ${tabletAndUpLinaria(`
    z-index: ${Z_INDEXES.FLYOUT_FADE_ON_DRAWER + 1};
  `)}
`;

const Headline = styled(Text)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.5;
`;
